<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        :title="ref"
        width="80%"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ this.ref }}</span>
            </Col>
          </Row>
        </div>
        <div style="text-align: center">
          <p class="font_size">
            工程质量样板虚拟体验软件由河南南秀数智科技有限公司开发运营，参照实际样板搭建场景，所有样板均融入交互式体验，使施工人员对工程质量交底的了解更充分彻底。
            建设工程质量关系到群众的切实利益与施工企业的生命。要保证工程施工质量，增强质量责任意识，要从施工过程的各个环节方面落实责任，全面推行质量保证体系。
            本软件对质量样板相关构件进行了全真模拟，涵盖建筑、结构、机电管道安装等几大块质量样板区域，工程质量样板虚拟体验软件以标准化模式开发研制，在工程项目中可普遍推广使用，并已逐渐成为了高端施工项目的标配。
            河南南秀数智科技有限公司竭诚为您服务。
          </p>
          <img
            width="80%"
            src="../../../static/img/photo-da/photo_AR.jpg"
            alt="暂无图片"
          />
          <img
            width="80%"
            src="../../../static/img/AboutUs/AR/AR_zhiliang02.jpg"
            alt="暂无图片"
          />
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      photoArr1: [
        {
          photoUrl: "../../../static/img/photo/photo_AR.jpg",
          photoUrl1: "../../../static/img/photo-da/photo_AR.jpg",
          ref: "AR质量样板应用体验APP",
          money: "¥10000.00",
          classify: [
            {
              type: "",
              money: "¥10000.00",
              img: "../../../static/img/photo-da/photo_AR.jpg",
            },
          ],
          title: "工法质量样板区",
          belong: "AR质量样板应用体验APP",
          path: "/home/Buy/AR",
        },
      ],
    };
  },
  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>
<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #f7f7f7;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/Buy/AR.vue